import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
    colors: {
        white: 'white',
        black: 'black',
        primary: '#004077',
        primaryBackground: '#004077',
        secondaryBackground: '#004077',
        grey: '#f4f4f4',
        greyishBrown: '#777777',
        greyishBrownTwo: '#444444',
        darkGrey: '#333333',
        derkerGrey: '#222222',
        brownishGrey: '#666666',
        blueGrey: '#96B0C3',
        lightBlue: '#004077',
        dividerColor: '#b7cbd9'
    },
    promotedSection: {
        colors: {
            primary: 'white'
        }
    }
};

export default theme;
